import React from 'react';
import Radium from 'radium';
import { Link } from 'react-router-dom';
import { shape, number, string, func, arrayOf } from 'prop-types';
import { ArrowBack } from '@material-ui/icons';
import { UTLabel, WithLoading } from '@widergy/energy-ui';

import { billPropTypes } from 'types/billTypes';
import { message } from 'utils/stringUtils';
import SecondaryTopbar from 'app/components/SecondaryTopbar';
import { appConfig } from 'config/customization';
import UTList from 'app/components/UTList';
import UTDownloadBill from 'app/components/UTDownloadBill';
import { ROUTES } from 'constants/routes';

import styles from './styles';

const BillDetails = ({ formattedBill, bill, onClickDownload }) => (
  <div style={styles.container}>
    <SecondaryTopbar titleText={message('Bill:detail')}>
      <Link to={ROUTES.BILLS}>
        <UTLabel>
          <ArrowBack style={styles.arrowBack} />
        </UTLabel>
      </Link>
    </SecondaryTopbar>
    <UTList list={formattedBill} />
    <div style={styles.downloadButtonContainer}>
      <UTDownloadBill
        loadingMessage={message('Bill:loadingBill')}
        title={message('AccountStatus:downloadBill')}
        onClickDownload={onClickDownload}
        billId={appConfig.bills.billDownloadOnPDF ? bill.download.external_id : bill.id}
        downloadUrl={bill.download.url}
        period={bill.download.period}
        amount={bill.download.amount}
        labelButton={message('Bills:download')}
        useIcon={appConfig.bills.downloadIconMobile}
        disabled={!bill.downloadable}
      />
    </div>
  </div>
);

BillDetails.propTypes = {
  formattedBill: arrayOf(
    shape({
      id: number,
      title: string,
      subtitle: string
    })
  ),
  bill: billPropTypes,
  onClickDownload: func.isRequired
};

export default WithLoading(props => props.loading)(Radium(BillDetails));
